module.exports = __webpack_public_path__ + "img/blue_174.034e6169.png";